var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 635,
    viewBox: "0 0 483 635",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M471.5 545C471.5 552.928 467.229 561.879 456.419 571.404C445.627 580.912 429.352 590 408.25 597.864C366.134 613.559 307.181 623.5 241.5 623.5C175.819 623.5 116.866 613.559 74.7496 597.864C53.6481 590 37.3726 580.912 26.5808 571.404C15.7711 561.879 11.5 552.928 11.5 545C11.5 537.072 15.7711 528.121 26.5808 518.596C37.3726 509.088 53.6481 500 74.7496 492.136C116.866 476.441 175.819 466.5 241.5 466.5C307.181 466.5 366.134 476.441 408.25 492.136C429.352 500 445.627 509.088 456.419 518.596C467.229 528.121 471.5 537.072 471.5 545Z",
    stroke: "white",
    strokeWidth: 23
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.5 534.5C146.967 414.843 44.5 286.5 39 208C58 -94.5 452.5 -41.5 443 208C440.735 267.5 337.943 410.432 243.5 534.5ZM241 286C297.333 286 343 240.333 343 184C343 127.667 297.333 82 241 82C184.667 82 139 127.667 139 184C139 240.333 184.667 286 241 286Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.4dd1bbb0fbe0f09abe337e9f8ad0e5b5.svg";
export { ForwardRef as ReactComponent };